import { STORY_VERSIONS } from '@monoimin/constants';

import { defineMergedParams } from './defineMergedParams';
import { newStoryblokApi } from './newStoryblokApi';

import { GetStoriesParams } from './types';

export const get = async <T>(slug: string, params?: GetStoriesParams) => {
  const mergedParams = await defineMergedParams(params);

  const { Storyblok } = newStoryblokApi(
    mergedParams.version === STORY_VERSIONS.DRAFT,
    'server'
  );

  return Storyblok.get(slug, mergedParams) as Promise<T>;
};
